const InquiryChargeNote = () => {
  return (
    <div>InquiryChargeNote</div>
  )
}

export default InquiryChargeNote